import { useSyncExternalStore } from 'react';

const MOBILE_QUERY = '(max-width: 767px)';

const subscribe = (onChange) => {
  const media = window.matchMedia(MOBILE_QUERY);
  media.addEventListener('change', onChange);
  return () => media.removeEventListener('change', onChange);
};

const getSnapshot = () => window.matchMedia(MOBILE_QUERY).matches;

// Match the site's mobile navigation breakpoint and preserve actual DOM/tab order.
export const useIsMobile = () => useSyncExternalStore(subscribe, getSnapshot, () => false);